import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) { }

  createUser(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/users/create`, data);
  }

  getUsers(searchTerm: string, limit: number, offset: number): Observable<any> {
    return this.http.get(`${environment.authUrl}/users`, {
      params: { searchTerm, limit, offset },
    });
  }

  getProfile(id: string = ''): Observable<any> {
    return this.http.get(`${environment.authUrl}/users/${id}`);
  }

  getRoles(): Observable<any> {
    return this.http.get(`${environment.authUrl}/role`);
  }

  getDropdownRoles(): Observable<any> {
    return this.http.get(`${environment.authUrl}/role/dropdown/list`);
  }


  updateUser(id: string, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/admin/update/${id}`, data);
  }

  updateProfile(id: string, data: any): Observable<any> {
    return this.http.patch(
      `${environment.authUrl}/admin/updateprofile/${id}`,
      data
    );
  }

  deleteUser(id: number): Observable<any> {
    return this.http.delete(`${environment.authUrl}/users/${id}`);
  }

  getAppUsers(
    search = '',
    filters: any = {},
    limit = 10,
    offset = 0
  ): Observable<any> {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());
    if (search) {
      params = params.set('searchTerm', search);
    }

    if (filters.startDate) {
      params = params.set('startDate', filters.startDate);
    }

    if (filters.endDate) {
      params = params.set('endDate', filters.endDate);
    }

    if (filters.membership) {
      params = params.set('membership', filters.membership);
    }

    if (filters.billingCycle) {
      params = params.set('billingCycle', filters.billingCycle);
    }

    if (filters.isNewsletterSubscribed !== undefined) {
      params = params.set('isNewsletterSubscribed', filters.isNewsletterSubscribed.toString());
    }

    return this.http.get(`${environment.authUrl}/parents`, { params });
  }

  getAllUsers(id: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/users/parent/${id}`);
  }

  exportAppUsers(): Observable<any> {
    return this.http.get(`${environment.authUrl}/appUsers/export`, {
      responseType: 'blob'
    });
  }

  deleteAppUser(userId: number) {
    return this.http.delete(`${environment.authUrl}/delete/${userId}`);
  }

  getUserDetails(id: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/users/parent/${id}`);
  }
}
